import React from 'react';
import FundraisingProgress from './FundraisingProgress';
import DonationList from './DonationList';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../styles/DonationHighlights.css';
import { ROUTES } from '../config';
import { FaArrowRight } from "react-icons/fa6";

export default function DonationHighlights({
  onViewAll,
  allDonationsHref = '/donations',
  className = '',
  refreshKey = 0,
}) {
  return (
    <section className={`donation-highlights donation-highlights--paper ${className}`}>
      {/* Top: big progress */}
      <div className="panel highlights-progress">
        <FundraisingProgress refreshKey={refreshKey} />
      </div>

      {/* Two cards */}
      <div className="highlights-grid">
        <div className="panel list-card">
          <h3 className="card-title">Recent donations</h3>
          <DonationList path={ROUTES.recent} refreshKey={refreshKey} />
        </div>

        <div className="panel list-card">
          <h3 className="card-title">Biggest donations</h3>
          <DonationList path={ROUTES.biggest} refreshKey={refreshKey} />
        </div>
      </div>

      {/* View donations */}
      <div className="highlights-cta">
        {onViewAll ? (
          <Button size="lg" className="view-all-btn" onClick={onViewAll}>
            View all donations <FaArrowRight />
          </Button>
        ) : (
          <Button
            as={Link}
            to={allDonationsHref}
            size="lg"
            className="view-all-btn"
          >
            View all donations <FaArrowRight />
          </Button>
        )}
      </div>
    </section>
  );
}
